<div class="wrap-row text" [ngClass]="getNgClass()">
    <div class="wrap-row-col-top" [ngClass]="getNgClass()">
        <div class="col-top-id">
            <span>{{ alarm.channel }}</span>
        </div>
        <div class="hr" [ngClass]="getNgClass()"></div>
        <div class="col-top-name" [class]="{ 'on-ack': alarm.UnAck }">{{ alarm.name | uppercase }}</div>
        <div class="hr" [ngClass]="getNgClass()"></div>
        <div class="col-top-status" [class]="{ 'on-ack': alarm.UnAck }">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <span>{{ alarm.status | uppercase }}</span>
        </div>
    </div>
    <div class="wrap-row-col-detail text-small" [ngClass]="getNgClass()">
        <p>
            {{ alarm.value }}<span *ngIf="alarm.value">&#x2022;</span>
            {{ alarm.category }}<span>&#x2022;</span
            >{{ "alarm.table.occurence" | translate }}
            {{ alarm.occurredAt | date: "yyyy/MM/dd" : "UTC" }} at
            {{ alarm.occurredAt | date: "HH:mm" : "UTC" }} UTC<span
                >&#x2022;</span
            >
        </p>
        <p>
            {{ "alarm.table.update" | translate }}
            {{ alarm.updatedAt | date: "yyyy/MM/dd" : "UTC" }} at
            {{ alarm.updatedAt | date: "HH:mm" : "UTC" }} UTC
        </p>
    </div>
    <div class="wrap-row-col-button" [ngClass]="getNgClass()">
        <button
            class="primary"
            (click)="emitAck()"
            [disabled]="disableAckButton"
        >
            {{ "alarm.button.acknowledge" | translate | uppercase }}
        </button>
    </div>
</div>
